import i18n from 'scoreboard/components/i18n'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import isGeographicOrRollup from '../datasets/is-geographic-or-rollup'

function showAllowRecordlessCopiesOption (field, useRanges) {
	if (field) {
		if (isGeographicOrRollup(field.dataType)) {
			// rollup fields always have the recordless option
			return true
		} else {
			// non-rollup fields can only have the recordless option if we're building
			// based on a range/category
			return useRanges
		}
	} else {
		return false
	}
}

function allowRecordlessCopiesLabel (field) {
	let objectType
	if (isGeographicOrRollup(field.dataType)) {
		objectType = 'datasets.dataType.rollupTreeItems'
	} else if (isNumericDataType(field.dataType)) {
		objectType = 'datasets.fields.ranges.numeric'
	} else {
		objectType = 'datasets.fields.ranges.text'
	}

	return i18n.get('template.paste.allowRecordlessCopies', objectType)
}

export { showAllowRecordlessCopiesOption }
export { allowRecordlessCopiesLabel }